































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { TbCommissionRule, TbGoods, TbGoodsClass, TbRole, TbShopAccount } from '@/http';
import { dialogPanel,logoutPanel } from "@/components"; 
import dayjs from 'dayjs';
import { Toast,Dialog } from 'vant';
@Component({ 
    components: {
        dialogPanel,logoutPanel
    },
})
export default class commissionRule extends Vue {
   
    public $refs: {
    };

    list = [];

    /**新增提成规则 */
    show=false;
    title="新增提成规则";
    isEdit = false;
    form:any={
        ruleName:"",
        appliesEmployee:"",
        expiryDate:"",
        enableStatus:true,
        commissionMethod:1,
        countRule:1,
        addCommissionScaleList:[]
    };
    isloading = false;
    steps=1;

    defaultVal1="全部员工";
    defaultVal2="不限";

    tcOptions=[
        {
            label:'按月会员充值额',
            value: 1,
        },
        {
            label:'按月销售额',
            value: 2,
        },
    ]
    jsOptions=[
        {
            label:'阶梯式计算',
            value: 1,
        },
        {
            label:'分段式计算',
            value: 2,
        },
    ]
    xsOptions=[
        {
            label:'设置上限',
            value: 1,
        },
        {
            label:'不设置上限',
            value: 2,
        },
    ]

    showTcPopover = false;
    showJsPopover = false;

    sxSelects= [
        {
            value:1,
            name:"设置上限",
            showPop:false,
        },
        {
            value:1,
            name:"设置上限",
            showPop:false,
        },
        {
            value:1,
            name:"设置上限",
            showPop:false,
        },
        {
            value:1,
            name:"设置上限",
            showPop:false,
        },
        {
            value:1,
            name:"设置上限",
            showPop:false,
        },
    ]
    czList = [
        {
            value:''
        },
        {
            value:''
        },
        {
            value:''
        },
        {
            value:''
        },
        {
            value:''
        },
    ]
    rateList = [
        {
            value:''
        },
        {
            value:''
        },
        {
            value:''
        },
        {
            value:''
        },
        {
            value:''
        },
    ]

    config={
        loop : [
            {
                number : 1,
                key : 'number-1',
            },
            {
                number : 2,
                key : 'number-2',
            },
            {
                number : 3,
                key : 'number-3',
            },
            {
                number : 4,
                key : 'number-4',
            },
            {
                number : 5,
                key : 'number-5',
            },
            {
                number : 6,
                key : 'number-6',
            },
            {
                number : 7,
                key : 'number-7',
            },
            {
                number : 8,
                key : 'number-8',
            },
            {
                number : 9,
                key : 'number-9',
            },
        ]
    }

    value=null;
    maxLength=10;

    editNumType = 1;
    editNumIndex = 0;

    /**提示弹窗 */
    tipShow = false;
    tipTitle ="";
    tipText="";
    confirmText="";
    cancelText="";
    btnNums=1;
    tipType=1;
    isTiping = false;

    Loop=null;

    deleteId = "";
    deleting = false;

    loading = false;

    refreshing= false;

    userInfo:any = {};

    get tcName(){
        let str = "";
        str = this.tcOptions.findIndex(v=>v.value==this.form.commissionMethod)>-1?this.tcOptions.find(v=>v.value==this.form.commissionMethod).label:'';
        return str;
    }
    get jsName(){
        let str = "";
        str = this.jsOptions.findIndex(v=>v.value==this.form.countRule)>-1?this.jsOptions.find(v=>v.value==this.form.countRule).label:'';
        return str;
    }

    created() {
        this.userInfo = JSON.parse(localStorage.getItem("padUserinfo"));
    }

    async mounted(){
        this.init();
       
    }
    onRefresh(){
        this.init();
        this.refreshing = false;
    }
    
    async init(){
        this.loading = true;
        try {
            let res= await TbCommissionRule.GetCommissionRuleList();
            this.list = res;
            this.loading = false;
        } catch (error) {
            this.loading = false;
        }
    }

    getQj(v,index,arr){
        let str="";
        let val1 = index==0?0:arr[index-1].amount.toFixed(2);
        let val2 = v.amount==0?'':v.amount.toFixed(2);
        str = val1+'~'+val2
        return str;
    }

    showAdd(){
        this.editNumType = 1;
        this.editNumIndex = 0;
        this.isEdit = false;
        this.title = "新增提成规则";
        this.show = true;
    }
    changeForbidden(val){
        this.form.enableStatus = val;
    }
    closeFun(){
        this.show = false;
        this.showTcPopover = false;
        this.showJsPopover = false;
        this.resetForm();
    }
    resetForm(){
        this.steps=1;
        this.form = {
            ruleName:"",
            appliesEmployee:"",
            expiryDate:"",
            enableStatus:true,
            commissionMethod:1,
            countRule:1,
            addCommissionScaleList:[]
        }
        this.sxSelects= [
            {
                value:1,
                name:"设置上限",
                showPop:false,
            },
            {
                value:1,
                name:"设置上限",
                showPop:false,
            },
            {
                value:1,
                name:"设置上限",
                showPop:false,
            },
            {
                value:1,
                name:"设置上限",
                showPop:false,
            },
            {
                value:1,
                name:"设置上限",
                showPop:false,
            },
        ]
        this.czList = [
            {
                value:''
            },
            {
                value:''
            },
            {
                value:''
            },
            {
                value:''
            },
            {
                value:''
            },
        ]
        this.rateList = [
            {
                value:''
            },
            {
                value:''
            },
            {
                value:''
            },
            {
                value:''
            },
            {
                value:''
            },
        ]
    }
    changeTcXL(v){
        this.form.commissionMethod = v.value;
        this.showTcPopover = false;
    }
    changeJsXL(v){
        this.form.countRule = v.value;
        this.showJsPopover = false;
    }
    preFun(){
        this.steps = 1;
    }
    nextFun(){
        if(!this.isEdit&&this.list.some(v=>v.commissionMethod==this.form.commissionMethod)){
            Toast("已存在相同规则的提成设置！");
            return
        }
        if(!this.form.ruleName){
            Toast("请输入规则名称");
            return
        }
        if(!this.form.countRule){
            Toast("请选择计算规则");
            return
        }
        this.steps = 2;
    }
    changeXsXL(val,index){
        if(this.sxSelects.some(v=>v.value==2)&&val.value==2){
            this.tipTitle = "操作提醒";
            this.tipText = `不可同时设置多条“不设置上限”的提成比例！`;
            this.btnNums=1;
            this.confirmText = "我知道了";
            this.cancelText = ""
            this.tipType = 3;
            this.tipShow = true;
            this.$set(this.sxSelects[index],'showPop',false);
            return;
        }
        this.$set(this.sxSelects[index],'value',val.value);
        this.$set(this.sxSelects[index],'name',val.label);
        if(val.value==2){
            this.$set(this.czList[index],'value',"");
        }
        this.$set(this.sxSelects[index],'showPop',false);
    }

    del() {
		if(!this.value) return;
            let index = this.value.length;
            this.value = this.value.toString().slice(0,index-1);
            this.finishFun();
        }
	number(number) {
		// this.$emit("number", number);
		let val = this.value;
		let dotIndex = this.value?this.value.toString().indexOf('.'):-1;
		if(number=='.'&&dotIndex>-1||this.value&&this.value.toString().length==this.maxLength) return;
		this.value = this.value?this.value.toString() + number.toString():number.toString();
		if(dotIndex>-1){
			if(val.toString().slice(dotIndex+1).length>1){
				this.value = this.value.slice(0,dotIndex+3)
			}
		}else{
			this.value = this.value.slice(0,this.maxLength)
		}
		this.finishFun();
	}


	clearFun(){
            this.value = null;
            this.finishFun();
    }
    finishFun(){
        if(this.editNumType==1){
            if(this.sxSelects[this.editNumIndex].value==2) return;
            this.$set(this.czList[this.editNumIndex],'value',this.value)
        }else{
            // if(this.value&&this.value<1){
            //     this.value = 1;
            //     this.$set(this.rateList[this.editNumIndex],'value',1);
            // }else 
            if(this.value>10000){
                this.value = 10000;
                this.$set(this.rateList[this.editNumIndex],'value',10000);
            }else{
                this.$set(this.rateList[this.editNumIndex],'value',this.value);
            }
        }
    }

    setNumVal(val,type,index){
        this.value = val;
        this.editNumType = type;
        this.editNumIndex = index;
        this.maxLength = type==1?10:5;
    }

    confirmSave(){
        let val = false;
        let str = this.form.commissionMethod==1?'充值额':'销售额';
        if(this.sxSelects.filter(v=>v.value==2).length==0&&this.rateList.filter(v=>v.value).length==0){
            val = true;
            Toast("请维护至少一条提成比例规则")
        }
        this.sxSelects.forEach((v,index)=>{
            if(v.value==1&&!this.czList[index].value&&this.rateList[index].value){
                Toast("请输入对应提成比例的充值额")
                val = true
            }
            if(v.value==2&&!this.rateList[index].value){
                Toast("请输入不设置上限的提成比例")
                val = true
            }
        })
        this.czList.forEach((v,index)=>{
            if(v.value&&Number(v.value)==0){
                Toast(`${str}不能为0`)
                val = true
            }
            if(v.value&&!this.rateList[index].value){
                Toast(`请输入对应${str}的提成比例`)
                val = true
            }
        })
        let arr = this.czList.filter(v=>v.value).map(v=>Number(v.value));
        
        if(new Set(arr).size!=arr.length){
            Toast(`${str}不能重复`)
            val = true
        }
        if(this.rateList.some(v=>v.value&&Number(v.value)==0)){
            Toast("提成比例请输入1-100")
            val = true
        }
        if(this.rateList.some(v=>v.value&&Number(v.value)>100)){
            Toast("提成比例请输入1-100")
            val = true
        }
        if(val) return;

        this.tipTitle = "操作提醒";
        this.tipText = `确定保存吗？`;
        this.btnNums=2;
        this.confirmText = "确认";
        this.cancelText = "取消"
        this.tipType = 1;
        this.tipShow = true;

    }

    async deleteFun(){
        if(this.deleting) return;
        this.deleting = true;
        try {
            let res = await TbCommissionRule.DeleteCommissionRule(this.deleteId);
            await this.init();
            Toast("删除成功");
            this.deleting = false;
        } catch (error) {
            this.deleting = false;
        }
    }

    /**提示弹窗 */
    async tipConfirm(){
        if(this.tipType==1){
            this.addFun();
        }else if(this.tipType==2){
            this.deleteFun();
        }
        this.tipShow = false;
    }
    tipCancel(){
        this.tipShow = false;
    }

    formateArr(){
        let newarr= [];
        let arr= [];
        this.rateList.forEach((v,index)=>{
            if(v.value){
                arr.push({
                    amount:this.czList[index].value,
                    commissionScale:v.value
                })
            }
        })
        arr.sort((a,b)=>a.amount-b.amount);
        newarr = [...arr.filter(v=>v.amount),...arr.filter(v=>!v.amount)].map((v,index)=>{
            return{
                ...v,
                amount:v.amount?v.amount:0,
                sort:index+1
            }
        })
        return newarr;
    }

    async addFun(){
        if(this.isloading) return;
        this.isloading = true;
        if(!this.isEdit){
            try {
                let obj = Object.assign({},this.form,{
                    addCommissionScaleList:this.formateArr()
                })
                // console.log('obj',obj);
                let res = await TbCommissionRule.PostAddCommissionRule(obj);
                await this.init();
                this.isloading = false;
                Toast("保存成功");
                this.closeFun();
                
            } catch (error) {
                this.isloading = false;
            }            
        }else{
            try {
                let obj = {
                    id:this.form.id,
                    ruleName:this.form.ruleName,
                    appliesEmployee:this.form.appliesEmployee,
                    expiryDate:this.form.expiryDate,
                    enableStatus:this.form.enableStatus,
                    commissionMethod:this.form.commissionMethod,
                    countRule:this.form.countRule,
                    addCommissionScaleList:this.formateArr(),
                }
                // console.log('obj',obj);
                let res = await TbCommissionRule.PutUpdateCommissionRule(obj);
                await this.init();
                this.isloading = false;
                Toast("保存成功");
                this.closeFun();
                
            } catch (error) {
                this.isloading = false;
            }          
        }
    }
    clickCount:number = 0;
    itemRow(item){
        this.clickCount++
        setTimeout( async ()=>{
            if(this.clickCount == 1){
                this.clickCount = 0
                this.editRow(item);
            }else if(this.clickCount>1){
                this.clickCount = 0
                await this.touchstart(item)
                setTimeout( async ()=>{
                    await this.touchend()
                },200)
            }
        },300)
    }
    async editRow(item){
        if(!this.userInfo.isPrimary) return;
        if(!this.hasAuth('903')){
            Dialog.alert({
                title: '提示',
                message: "暂无操作权限",
                confirmButtonText: '确定',
                confirmButtonColor:'#0491A7'
                }).then(() => {
                
                });
            return;
        }
        let res = await TbCommissionRule.GetCommissionRuleById({id:item.id});
        this.form = res;
        this.isEdit = true;
        this.title = "编辑提成规则";
        this.editNumType = 1;
        this.editNumIndex = 0;
        this.show = true;
        res.getCommissionScaleList.forEach((v,index)=>{
            this.$set(this.rateList[index],'value',v.commissionScale);
            this.$set(this.czList[index],'value',v.amount!=0?v.amount:null);
            if(!v.amount){
                this.$set(this.sxSelects[index],'value',2);
                this.$set(this.sxSelects[index],'name','不设置上限');
            }
        })
    }

    touchstart(item){
        if(!this.userInfo.isPrimary) return;
        console.log('touchstart');
        clearInterval(this.Loop); //再次清空定时器，防止重复注册定时器
        this.Loop = setTimeout(function() {
            if(!this.hasAuth('904')){
                Dialog.alert({
                    title: '提示',
                    message: "暂无操作权限",
                    confirmButtonText: '确定',
                    confirmButtonColor:'#0491A7'
                    }).then(() => {
                    
                    });
                return;
            }
            this.tipTitle = "删除提醒";
            this.tipText = `确定删除“${item.ruleName}”提成规则吗？`;
            this.btnNums=2;
            this.confirmText = "确认";
            this.cancelText = "取消"
            this.tipType = 2;
            this.deleteId = item.id;
            this.tipShow = true;
        }.bind(this), 200);//手指或者鼠标按下等待的时间
    }
    touchend(){
        console.log('touchend');
        clearInterval(this.Loop);
    }
    /**判断权限 */
    hasAuth(auth) {
        let val = false;
        let btnPermissionsStr = this.userInfo['authorityJson'].split(',');
        if (btnPermissionsStr == undefined || btnPermissionsStr == null) {
        val = false;
        }
        if (btnPermissionsStr.some(v=>v==auth)) {
        val = true;
        }
        return val;
    }

    
   
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/staff/components/commissionRule.vue